module.exports = __webpack_public_path__ + "img/MYPORT.18ca150d.png";